import { useEffect } from "react";
import "./App.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Toaster } from "./components/ui/sonner";
import { Nav, CornerFrame } from "./components/Nav";
import { HumanStandard } from "./components/HumanStandard";
import { WaitlistProvider } from "./components/WaitlistDialog";
import { Stage3D } from "./components/Stage3D";
import { ServicesGrid } from "./components/ServicesGrid";
import { TrustStrip } from "./components/TrustStrip";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

gsap.registerPlugin(ScrollTrigger);

export default function App() {
  // Section reveals for the post-stage content
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;
    const ctx = gsap.context(() => {
      gsap.utils.toArray("[data-reveal]").forEach((el) => {
        gsap.from(el, {
          opacity: 0,
          y: 44,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", once: true },
        });
      });
    });
    // ensure trigger positions are right after fonts/layout settle
    const t = setTimeout(() => ScrollTrigger.refresh(), 600);
    return () => {
      clearTimeout(t);
      ctx.revert();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <WaitlistProvider>
      <Nav />
      <CornerFrame />
      <main>
        <Stage3D />
        <HumanStandard />
        <ServicesGrid />
        <TrustStrip />
        <FinalCTA />
      </main>
      <Footer />
      </WaitlistProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        visibleToasts={3}
        closeButton
        toastOptions={{
          classNames: {
            toast: "axt-toast",
            closeButton: "bg-black border-white/30 text-white hover:bg-white hover:text-black",
          },
        }}
      />
    </div>
  );
}
